
export function scrollContainerToAnchor(
  anchorId: string,
  options?: { behavior?: ScrollBehavior; block?: ScrollLogicalPosition }
) {
  const behavior = options?.behavior ?? "smooth";
  const block = options?.block ?? "start";

  const anchorEl = document.getElementById(anchorId);
  if (!anchorEl) return;

  // Find the nearest scrollable ancestor
  const getScrollableAncestor = (node: HTMLElement | null): HTMLElement | null => {
    let current: HTMLElement | null = node?.parentElement ?? null;
    while (current) {
      try {
        const style = window.getComputedStyle(current);
        const overflowY = (style.overflowY || style.overflow) as string;
        const isScrollable = /(auto|scroll|overlay)/.test(overflowY);
        if (isScrollable && current.scrollHeight > current.clientHeight) return current;
      } catch {}
      current = current.parentElement;
    }
    return (document.scrollingElement as HTMLElement) ?? null;
  };

  const container = getScrollableAncestor(anchorEl);
  if (!container) {
    // Fallback to default scroll behavior if no container found
    try {
      anchorEl.scrollIntoView({ behavior, block });
    } catch {}
    return;
  }

  try {
    const anchorRect = anchorEl.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    const offsetTop = anchorRect.top - containerRect.top + container.scrollTop;

    container.scrollTo({
      top: offsetTop,
      behavior: behavior === "smooth" ? "smooth" : "auto",
    });
  } catch {
    try {
      anchorEl.scrollIntoView({ behavior, block });
    } catch {}
  }
}
